<ng-container wp-isolated-query-space>
  <settings-tab-inner #tabInner></settings-tab-inner>
</ng-container>

